export class VariableLegend {
    alert?: number;
    control?: number;
    damage?: number;
}